// extracted by mini-css-extract-plugin
export default {"slideItem":"index_slideItem_MEPDs clearfix","sonItem":"index_sonItem_UdivP","slides":"index_slides_bhEyi"};